import React, { useState } from 'react';

import { Accordion, Flex, Text, Title, useMantineTheme } from '@mantine/core';
import { UpgradePlanLine } from 'components/UpgradePlanLine';

interface AdvancedAccordionProps {
  title: string;
  description: string;
  isEnabled: boolean;
  children: React.ReactNode;
}

export function AdvancedAccordion({ title, description, isEnabled, children }: AdvancedAccordionProps) {
  const theme = useMantineTheme();
  const [value, setValue] = useState<string | null>(null);

  const handleAccordionChange = (newValue: string | null) => {
    if (!isEnabled) return;
    setValue(newValue);
  };

  return (
    <Accordion
      styles={{
        item: {
          border: `1px solid ${theme.colors.gray[2]}`,
          marginTop: theme.spacing.md,
          borderRadius: theme.radius.md
        },
        panel: {
          padding: '12px'
        },
        control: {
          padding: theme.spacing.sm,
          '&:hover': {
            backgroundColor: 'transparent'
          },
          cursor: !isEnabled ? 'default' : 'pointer'
        },
        label: {
          padding: 0
        },
        chevron: {
          margin: 0,
          minWidth: !isEnabled ? 0 : undefined,
          width: !isEnabled ? 0 : undefined
        },
        content: {
          padding: 0,
          paddingTop: '0px',
          paddingBottom: '12px'
        }
      }}
      chevron={!isEnabled ? <></> : undefined}
      transitionDuration={0}
      value={value}
      onChange={handleAccordionChange}>
      <Accordion.Item value="item">
        <Accordion.Control>
          <Flex justify="space-between" align="center">
            <Flex direction="row" gap="" align="center" style={{ flex: 1 }}>
              <Flex direction="column" gap={3} maw="80%">
                <Title order={4} fw={600} lineClamp={1}>
                  {title}
                </Title>
                <Text size="sm" c="dimmed" lineClamp={2}>
                  {description}
                </Text>
              </Flex>
            </Flex>
            {!isEnabled && <UpgradePlanLine style={{ flexShrink: 0 }} />}
          </Flex>
        </Accordion.Control>
        <Accordion.Panel>{children}</Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
}
